export default {
  //  indonesia
  categoryMs: 'Category',
}
